<template>
	<div class="container-details">
		<div class="single" v-wechat-title="this.seoTitle"></div>
		<!-- 公共头部 -->
		<home-header></home-header>
		<!-- banner -->
		<div class="banner-info"></div>
		<!--新闻详情页-->
		<div class="detail-info">
			<div class="detail-title">{{cmsTitle}}</div>
			<div class="detail-desc" v-html="cmsContent" style="width:100%;">{{cmsContent}}</div>
			<div class="detail-clicks">阅读量：{{clicks}}</div>
			<div class="detail-seo">关键字：{{seoTags}}</div>
			<div class="detail-next">
				<span @click="beforeNext">上一篇新闻</span>&nbsp;&nbsp;&nbsp;
				<!--<span @click="afterNext">下一篇</span>-->
				<span @click="afterNext" class="after">下一篇新闻</span>
			</div>
			<!-- 相关推荐部分 -->
			<div class="detail-next">
				<!--@click="cmsRecommend"-->
				<p class="tuijian">相关推荐：</p>
				<router-link :key="index" :value="item.key" v-for="(item,index) in recommendList" @click.native="toRecommendDetail()" :to="{path: '/newsDetails', query: {cmsId:item.cmsId }}">
					<div class="right-item">
						<p class="news-title"><span class="z1">|</span> {{item.cmsTitle}}</p>
						<!--<p class="news-desc">{{item.cmsDesc}}</p>-->
					</div>
				</router-link>
			</div>
		</div>
		<!-- 公共版权 -->
		<home-footer></home-footer>
	</div>
</template>
<script>
	import HomeHeader from "@/components/homeHeader";
	import HomeFooter from "@/components/homeFooter";
	import { getInfoNews, beforeNext, afterNext, getList } from "../apis/apis.js";
	export default {
		name: "NewsDetails",
		components: {
			HomeHeader,
			HomeFooter
		},
		data() {
			return {
				cmsId: "",
				ImgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
				cmsContent: "",
				cmsTitle: "",
				clicks: "",
				seoTags: "",
				seoTitle: "",
				seoKeywords: "",
				seoDescription: "",
				data: [],
				//				cmsRecommend: '',
				recommendList: [],
				cmsDesc: ''
			};
		},
		metaInfo() {
			return {
				meta: [{
						name: 'description',
						content: this.seoDescription
					},
					{
						charset: 'utf-8'
					},
					{
						name: 'Keywords',
						content: this.seoKeywords
					}
				]
			}
		},
		methods: {
			//获取新闻详情页
			async getInfoNews(id) {
				try {
					let data = await getInfoNews(id);
					this.cmsContent = data.data.data.cmsContent;
					this.clicks = data.data.data.clicks;
					this.cmsTitle = data.data.data.cmsTitle;
					this.seoTitle = data.data.data.seoTitle;
					this.seoDescription = data.data.data.seoDescription;
					this.seoKeywords = data.data.data.seoKeywords;
					this.seoTags = data.data.data.seoTags.replace(/#/g, "  ,");
					// 获取推荐列表数据 
					this.getRecommendList(data.data.data.cmsType);
					console.log("data", data)
				} catch(err) {}
			},
			//获取新闻列表上一篇
			async beforeNext() {
				try {
					let {
						data
					} = await beforeNext(this.cmsId);
					if(data.code == 1000) {
						if(data.data != null && data.data != undefined) {
							this.cmsId = data.data.cmsId;
							this.getInfoNews(this.cmsId);
							document.body.scrollTop = 0 // chrome
							document.documentElement.scrollTop = 0 // firefox
							window.pageYOffset = 0 // safari
						} else {
							this.$Message.success("最后一篇啦");
						}
					} else {}
				} catch(err) {
					console.log("服务器异常", err);
				}
			},
			//获取新闻列表下一篇
			async afterNext() {
				try {
					let {
						data
					} = await afterNext(this.cmsId);
					console.log("data.code", data.code)
					if(data.code == 1000) {
						if(data.data != null && data.data != undefined) {
							this.cmsId = data.data.cmsId;
							this.getInfoNews(this.cmsId);
							document.body.scrollTop = 0 // chrome
							document.documentElement.scrollTop = 0 // firefox
							window.pageYOffset = 0 // safari
						} else {
							//							this.$Message.success("最后一篇啦");
							alert("最后一篇啦")
						}
					} else {}
				} catch(err) {
					console.log("服务器异常111", err);
				}
			},
			//获取推荐列表数据
			async getRecommendList(cmsType) {
				console.log("cmsType", cmsType)
				try {
					let params = {
						pageSize: "30",
						pageNum: 1,
						cmsType: cmsType
					};
					let {
						data
					} = await getList(params);
					if(data.code == 1000) {
						//						console.log("保存接口返回的数据", data);
						this.getRand(data.data.content, 5);
					} else {

					}
				} catch(err) {
					console.log("服务器异常", err);
				}
			},
			//随机取出不重复得数据
			getRand(sourceData, num) {
				this.recommendList = [];
				for(let i = 0; i < sourceData.length; i++) {

					let len = sourceData.length - 1;

					let number = Math.floor(Math.random() * len); //生成随机数0-len之间的整数  len得提前减1
					if(sourceData[number].cmsId == this.cmsId) { //避免随机出当篇新闻
						continue;
					}
					this.recommendList.push(sourceData[number]);
					//数组截取掉，避免重复
					sourceData.splice(number, 1);
					if(this.recommendList.length >= num) {
						break;
					}
				}
			},
			toRecommendDetail() {
				this.cmsId = this.$route.query.cmsId; //获取列表页传递过来的ID
				if(this.cmsId != null && this.cmsId != undefined) {
					this.getInfoNews(this.cmsId);
				};
			},

		},
		watch: {
			cmsId(val) {
				let query = this.$router.history.current.query;
				let path = this.$router.history.current.path;
				//对象的拷贝
				let newQuery = JSON.parse(JSON.stringify(query));
				// 地址栏的参数值赋值
				newQuery.cmsId = val;
				this.$router.push({
					path,
					query: newQuery
				});
			}
		},
		mounted() {
			this.cmsId = this.$route.query.cmsId; //获取列表页传递过来的ID
			if(this.cmsId != null && this.cmsId != undefined) {
				this.getInfoNews(this.cmsId);
			}
		}
	};
</script>

<style>
	.banner-info {
		width: 100%;
		height: 200px;
		background: url('../assets/images/banner002.png');
		background-size: 100% 100%;
	}
	
	.detail-info {
		width: 95%;
		margin: 0 auto;
		margin-bottom: 50px;
	}
	
	.detail-title {
		color: #E58111;
		padding-top: 30px;
		line-height: 44px;
		font-size: 39px;
		line-height: 60px;
	}
	
	.detail-desc {
		padding-top: 30px;
		padding-bottom: 30px;
	}
	
	.detail-desc img {
		width: 100%;
		height: 100%;
	}
	.detail-clicks {
		margin-bottom: 10px;
		font-size: 28px;
		color: #333;
	}
	
	.detail-seo {
		font-size: 28px;
		color: #333;
	}
	
	.detail-next {
		margin-top: 10px;
		color: #333;
		font-size: 28px;
	}
	
	.detail-next span:hover {
		color: #E58111;
		cursor: pointer;
	}
	.after {
		float: right;
	}
	.tuijian {
		margin-bottom: 16px;
		font-size: 28px;
		margin-top:20px;
	}
	
	.right-item {
		border-top: 1px solid #eee;
		height: 80px;
		/*line-height:80px;*/
		/*margin-top:35px;*/
		background: #F8F8F9;
		margin-bottom: 10px;
	}
	
	.news-title {
		font-size: 27px;
		color: #E58111;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-top:19px;
	}
	.news-title:before{
		content: "";
		background: url(../assets/images/Icon-01.png) no-repeat;
		background-size: 100%;
		display: inline-block;
		width: 36px;
		height: 36px;
		vertical-align: middle;
		margin:-5px 7px 0px 7px;
		}
	.news-desc {
		font-size: 24px;
		color: #333;
		white-space: nowrap;
		/*规定段落中的文本不进行换行*/
		overflow: hidden;
		/*内容会被修剪，并且其余内容是不可见的。*/
		text-overflow: ellipsis;
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/newsDetails.vue